export default __webpack_public_path__ + "static/media/praxis1.0093661e.webp";